export type {
	LineMember,
	LineStatus,
	MatchRule,
	ProductLineList,
	ProductLineRow,
	Result,
} from "@server/product-lines";

export const lineUrl = (slug: string) =>
	`https://www.priceonline.dk/produkter/${encodeURIComponent(slug)}`;
